import { formatItemSchedule } from '@src/common/utils/formatItemSchedule';
import type { useTranslate } from '@src/core/hooks';
import type { CartItem } from '@src/domains/cart';
import type { DetailedSaleItem } from '@src/domains/orders';

type GetFormattedItemDateParams = {
  item: CartItem | DetailedSaleItem;
  i18n: ReturnType<typeof useTranslate>['i18n'];
};

export const getFormattedItemDate = ({ item, i18n }: GetFormattedItemDateParams): string =>
  formatItemSchedule(item, {
    fallbackText: i18n('checkout_purchase_summary_without_date'),
  });
